<fieldset>
  <mat-form-field appearance="standard">
    <mat-label>mm/dd/yyyy</mat-label>
    <input matInput
           [readonly]="disabled"
           [matDatepicker]="picker"
           [value]="value"
           (dateInput)="onDateChange($event)"
           (dateChange)="onDateChange($event)"
           (blur)="onTouch($event)"
           appPopulateDate>
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker [disabled]="disabled"></mat-datepicker>
  </mat-form-field>
</fieldset>
